import React from "react";
import { TooltipProps, Box } from "@mui/material";

import { AdminTooltip } from "./styles";

type TooltipT = {
  children: JSX.Element;
  placement: TooltipProps["placement"];
  containerStyle?: React.CSSProperties;
} & TooltipProps;

export const Tooltip = ({ title, placement, children, containerStyle = {}, ...rest }: TooltipT) => {
  return (
    <Box sx={{ cursor: "pointer", ...containerStyle }}>
      <AdminTooltip {...rest} placement={placement} arrow title={title}>
        {children}
      </AdminTooltip>
    </Box>
  );
};
